import StorefrontLayout from "./storefront"
import DashboardLayout from "./dashboard"

export { StorefrontLayout, DashboardLayout }
